import { Colors } from "../../../../utils/colors";
import { LessThanDate, roundTimeInterval } from "@markit/common.utils";
import IOSSwitch from "../../../IOSSwitch";
import { useTheme } from "../../../../hooks/useTheme";
import { useCallback, useState } from "react";
import AlertContainer from "../../../Containers/AlertContainer";
import { ScheduleTextInfo } from "@markit/common.types";
import StandardBorderedContainer from "../../../Containers/StandardBorderedContainer";
import DateTimePickerInput from "../../../DateTimePickerInput";

type MassTextSendTimeProps = {
  scheduleTextInfo: ScheduleTextInfo;
  setScheduleTextInfo: (scheduleTextInfo: ScheduleTextInfo) => void;
  isEditing: boolean;
};

export const MassTextSendTime = (props: MassTextSendTimeProps) => {
  const { scheduleTextInfo, setScheduleTextInfo, isEditing } = props;
  const { theme } = useTheme();
  const [alertText, setAlertText] = useState("");

  const styles = {
    sectionContainer: {
      backgroundColor: Colors.WHITE1,
      paddingBlock: 14,
    },
  };

  const toggleSendTime = useCallback(() => {
    // round the time up to the nearest 5 minute interval, set 10 min after current date
    // Ex: 10:14 => 10:25
    let newSentAt = scheduleTextInfo.sentAt;
    if (!scheduleTextInfo.scheduleToggle) {
      const roundedTime = roundTimeInterval(new Date().toISOString(), 5);
      newSentAt = roundedTime.toISOString();
    }
    setScheduleTextInfo({
      ...scheduleTextInfo,
      sentAt: newSentAt,
      scheduleToggle: !scheduleTextInfo.scheduleToggle,
    });
  }, [scheduleTextInfo, setScheduleTextInfo]);

  return (
    <>
      <StandardBorderedContainer
        containerStyles={{ ...styles.sectionContainer, paddingInline: 14 }}
      >
        <div
          className="AlignedRowSpaced"
          style={{ marginBottom: scheduleTextInfo.scheduleToggle ? 14 : 0 }}
        >
          <div className="ColumnNormal" style={{ gap: 3 }}>
            <span
              className="EventDashboardContentHeader"
              style={theme.PrimaryText}
            >
              Schedule this text
            </span>
            <div
              className="EventDashboardContentDescription"
              style={{ color: Colors.GRAY1 }}
            >
              Send this text at a later scheduled time.
            </div>
          </div>
          <IOSSwitch
            sx={{ m: 1 }}
            checked={scheduleTextInfo.scheduleToggle}
            onChange={toggleSendTime}
            disabled={isEditing}
          />
        </div>
        {scheduleTextInfo.scheduleToggle ? (
          <div className="AlignedRowSpaced">
            <span
              className="AboutSubtitle"
              style={{
                fontSize: 14,
                fontWeight: 500,
                whiteSpace: "nowrap",
                marginRight: 20,
                ...theme.PrimaryText,
              }}
            >
              Set Send Time
            </span>
            <DateTimePickerInput
              timestamp={scheduleTextInfo.sentAt}
              onChange={(date) => {
                if (date != null) {
                  if (
                    LessThanDate(date.toISOString(), new Date().toISOString())
                  ) {
                    setAlertText(
                      "You cannot edit the send time to be prior to the current time."
                    );
                    return;
                  }
                  setScheduleTextInfo({
                    ...scheduleTextInfo,
                    sentAt: date.toISOString(),
                  });
                }
              }}
            />
          </div>
        ) : null}
      </StandardBorderedContainer>
      <AlertContainer
        headerComp={alertText}
        theme={theme}
        closeModal={() => setAlertText("")}
        hideModal={alertText === ""}
      />
    </>
  );
};
